import PropTypes from 'prop-types';
import React from 'react';
import MarinoPreview from './previews/MarinoPreview';
import MinimoPreview from './previews/MinimoPreview';
import PalmaPreview from './previews/PalmaPreview';
import PassportPreview from './previews/PassportPreview';
import ViaggioPreview from './previews/ViaggioPreview';

function WalletPreview({ walletType = 'marino', ...props }) {
  switch (walletType) {
    case 'marino':
      return <MarinoPreview {...props} />;
    case 'minimo':
      return <MinimoPreview {...props} />;
    case 'palma':
      return <PalmaPreview {...props} />;
    case 'viaggio':
      return <ViaggioPreview {...props} />;
    case 'passport':
      return <PassportPreview {...props} />;
    default:
      return null;
  }
}

WalletPreview.propTypes = {
  walletType: PropTypes.string,
  // Define other prop types here
};

export default WalletPreview;
